import { ReactNode, ComponentType } from "react";

type Variant = "info" | "warning" | "success";

interface InfoAlertProps {
  icon?: ComponentType<{ className?: string }>;
  children: ReactNode;
  variant?: Variant;
  className?: string;
}

const variantStyles: Record<Variant, string> = {
  info: "bg-blue-50 dark:bg-blue-950/20 border-blue-200 dark:border-blue-900 text-blue-800 dark:text-blue-300",
  warning: "bg-yellow-50 dark:bg-yellow-950/20 border-yellow-200 dark:border-yellow-900 text-yellow-800 dark:text-yellow-300",
  success: "bg-green-50 dark:bg-green-950/20 border-green-200 dark:border-green-900 text-green-800 dark:text-green-300",
};

const iconStyles: Record<Variant, string> = {
  info: "text-blue-600 dark:text-blue-400",
  warning: "text-yellow-600 dark:text-yellow-400",
  success: "text-green-600 dark:text-green-400",
};

export function InfoAlert({
  icon: Icon,
  children,
  variant = "info",
  className = "",
}: InfoAlertProps) {
  return (
    <div className={`flex items-start gap-2 p-3 rounded-lg border ${variantStyles[variant]} ${className}`}>
      {Icon && <Icon className={`w-4 h-4 mt-0.5 flex-shrink-0 ${iconStyles[variant]}`} />}
      <div className="text-sm">{children}</div>
    </div>
  );
}
